module.exports = __webpack_public_path__ + "media/images/logo-otec-achsv1-aad35bb84256568875edbcb2a9716c2e.png";